import { useParams } from 'react-router-dom';
import { useTermine } from '../../../hooks/useTermine';
import { LoadingFallback } from './LoadingFallback';
import { TermineTooltip } from './TermineTooltip';
import { Suspense } from 'react';
import { ErrorBoundary } from '@/components';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { TerminePopover } from '@/domain/arbeitszeiten/pages/uebersicht/Termine/TerminePopover';
import { ErrorFallback } from '@/domain/arbeitszeiten/pages/uebersicht/Termine/ErrorFallback';

export function Termine() {
  const { year, month, day } = useParams();
  const { currentStandort: standort } = useStandortContext();
  const date = new Date(`${year}-${month}-${day}`);
  const termine = useTermine(standort.id, date);

  return (
    <Suspense fallback={<LoadingFallback />}>
      <ErrorBoundary FallbackComponent={() => <ErrorFallback />}>
        <TermineTooltip termine={termine} />
        <TerminePopover termine={termine} />
      </ErrorBoundary>
    </Suspense>
  );
}
